// extracted by mini-css-extract-plugin
export var buyLink = "styles-module__buyLink___tmpcN";
export var container = "styles-module__container___g95Iq";
export var image = "styles-module__image___mxMD_";
export var imageAndTextContainer = "styles-module__imageAndTextContainer___tGlV1";
export var imageContainer = "styles-module__imageContainer___oTpGp";
export var logoPlusImage = "styles-module__logoPlusImage___ezrzG";
export var text = "styles-module__text___wQZup";
export var textContainer = "styles-module__textContainer___tzrPh";
export var title = "styles-module__title___OlT7K";